var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eyTit"},[_c('h1',{staticClass:"main"},[_vm._v(_vm._s(_vm.main))]),_c('h6',{staticClass:"sub"},[_vm._v(_vm._s(_vm.sub))])])
}
var staticRenderFns = []

export { render, staticRenderFns }